export default __webpack_public_path__ + "static/media/New_VF_Logo_Horiz_RGB_RED.2ab28d57.jpg";